import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteProject } from '@/api/v4/projects.api';
import { QueryKey } from '@/config/query-client';

export const useDeleteProject = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteProject,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKey.ProjectsKpi] }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.Projects] }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.ProjectOptions] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.CompaniesStatistics],
        }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.LastActivities] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.LastActivitiesCount],
        }),
      ]);
    },
  });
};
